/**
 * Gesture handlers for every Admin dashboard map (operator, rep, site and Sales Partner), at every width. All of them stay on
 * and cooperativeGestures stays off, so a mouse drag or a one-finger touch drag pans, the wheel or a pinch zooms, and the
 * "use two fingers" overlay never shows (Warren, 22 October 2026: the map must be grabbed and panned with a mouse and with one
 * finger on a phone). On a phone a gesture that starts on a card still scrolls the page. Marker clicks are DOM clicks on the
 * marker elements, not map gestures, so they fire either way.
 *
 * Kept apart from MapContainer, which imports mapbox-gl and its stylesheet, so the node test can read these options.
 */
export const DASHBOARD_MAP_GESTURES = {
  dragPan: true,
  touchZoomRotate: true,
  scrollZoom: true,
  touchPitch: true,
  boxZoom: true,
  dragRotate: true,
  // A right-drag rotates without tilting; tilt is the two-finger vertical drag (touchPitch).
  pitchWithRotate: false,
  cooperativeGestures: false,
} as const;
